import React from "react";
import ContactForm from "../Components/ContactForm/index";
// import BoxesSection from "./Components/BoxesSection/index";


const Contact = () => {
    return (
        <>
            <ContactForm />
            {/* <BoxesSection /> */}
        </>
    );
}

export default Contact;